<template>
  <div class="universe-configurator">
    <h2 :class="{show:(universeRoles || unlockUniverse)}">
            <span class="icon-container">
                <span class="icon-inner">
                    <component v-bind:is="universeIcon" class="universe-icon" :class="universeClass"></component>
                </span>
            </span>
      <span class="universe-title">{{ universeName }}</span>
      <span class="switch-container">
                <span class="switch" v-if="universeRoles || unlockUniverse">
                    <input type="checkbox"
                           v-model="unlockUniverse"
                           @change=""
                           :true-value="true"
                           :false-value="false"/>
                    <span class="yes"><font-awesome-icon icon="lock-open"/></span><!--
                                    --><span class="no"><font-awesome-icon icon="lock"/></span>
                </span>
            </span>
    </h2>

    <div class="universe-configurator-container" :class="{show:(universeRoles || unlockUniverse)}">
      <div class="mobile-container roles-container" v-if="definition && definition.handleRole">
        <h3 @click="toggleRoles">
          <span>{{ $t('users.role') }}</span></h3>
        <div class="mobile-container-inner roles-container-inner">
          <div class="mobile-container-content">
            <div class="role-selector" :class="{empty:!universeRoles}"
                 @click="handleShowModal">
              <template v-if="!universeRoles">
                <font-awesome-icon icon="plus-circle"/>
                {{ $t('users.addProfile') }}
              </template>
              <template v-else>
                <span v-if="$te('users.roles.id_'+universeRoles['id'])">{{ $t('users.roles.id_'+universeRoles['id']) }}</span>
                <span v-else>{{ universeRoles['display_name'] }}</span>
                <p v-if="$te('users.roles.id_'+universeRoles['id'])" v-html="$t('users.roles.description_'+universeRoles['id'])"></p>
                <p v-else v-html="universeRoles['description']"></p>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="mobile-container groups-container" v-if="definition && definition.handleGroups">
        <h3 @click="toggleGroups">
          <span>{{ $t('users.group') }}</span>
          <FilterField @filter="handleGroupFilter" v-if="!roleBypassGroupManagment"/>
        </h3>

        <div class="mobile-container-inner groups-container-inner" :class="{readonly:isReadOnlyGroups}"
             v-if="!roleBypassGroupManagment && filteredGroups.length > 0">

          <div class="mobile-container-content">
            <template v-for="group in filteredGroups">

              <div v-if="group.parentId == null" class="group-card" :class="{active:group.selected}"
                   @click="handleCheckGroup(group)">
                <span :title="group.name">{{ group.name }}</span>
                <div class="icon">
                  <font-awesome-icon icon="check"/>
                </div>
              </div>

              <template v-for="subgroup in filteredGroups">

                <div v-if="subgroup.parentId == group.id" class="group-card" :class="{active:subgroup.selected}"
                     @click="handleCheckGroup(subgroup)" style="margin-left:25px;">

                  <span :title="subgroup.name">
                    <font-awesome-icon icon="level-up-alt" class="fa-rotate-90" style="margin-left:8px; margin-right:4px; color:#c6c6c6"/>
                    {{ subgroup.name}}
                  </span>

                  <div class="icon">
                    <font-awesome-icon icon="check"/>
                  </div>

                </div>

              </template>
            </template>
          </div>
        </div>

        <div class="groups-helpers" v-if="!roleBypassGroupManagment && filteredGroups.length > 0">
          <a href="#" @click.prevent="uncheckAllGroups"> {{ $t('global.none') }}</a>
          <a href="#" @click.prevent="checkAllGroups"> {{ $t('global.all') }}</a>
        </div>

        <div style="padding-top: 10px;font-style: italic" v-if="roleBypassGroupManagment" v-html="$t('users.giveUniversAccess')">
        </div>

        <div style="padding-top: 10px;font-style: italic" v-if="filteredGroups.length == 0">
          {{ $t('users.groupListEmpty') }}
        </div>
      </div>
    </div>

    <div class="universe-configurator-container" :class="{show:!(universeRoles || unlockUniverse)}">
      <div class="lock-message">
        <font-awesome-icon icon="lock"/>
        <p v-html="$t('users.giveUniversAccess')">
        </p>

        <div class="switch">
          <input type="checkbox"
                 v-model="unlockUniverse"
                 @change=""
                 :true-value="true"
                 :false-value="false"/>
          <span class="yes"><font-awesome-icon icon="lock-open"/></span><!--
                                --><span class="no"><font-awesome-icon icon="lock"/></span>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
//import Component from 'path/to/component'

import Vue from 'vue'

import FilterField from '@c/ui/Filter'

import RolesList from '@v/users/RolesList'

import {mapGetters, mapMutations, mapActions, mapState} from 'vuex'
import _find from 'lodash/find'
import _forEach from 'lodash/forEach'

import Utils from '@s/utils'

export default {
  beforeCreate: function () {

  },
  beforeDestroy: function () {

  },
  beforeMount: function () {

  },
  beforeUpdate: function () {

  },
  components: {
    FilterField
  },
  computed: {
    ...mapState('Users', {}),
    ...mapGetters({
      rolesList: 'Roles/roles',
      groupsList: 'Groups/groups',
      selectedUser: 'Users/selectedUser',
      selectedUserRoles: 'Users/selectedUserRoles',
      selectedUserGroups: 'Users/selectedUserGroups',
      isReadOnlyGroups: 'Papers/isReadOnlyGroups',
      clientInfos: 'Papers/clientInfos'
    }),
    /*selectedUserRoles: {
        get(){
            return this.$store.state.Users.selectedUserRoles
        },
        set(value){
            this.$store.commit('Users/selectedUserRoles',value)
        }
    },*/
    universeIcon() {
      if (this.definition) {
        return this.definition.icon
      }
      return null
    },
    universeName() {
      if (this.definition) {
        return this.definition.name
      }
      return ""
    },
    universeClass() {
      if (this.definition) {
        return this.definition.class
      }
      return ""
    },
    universeRoles() {
      if (this.definition) {
        if (this.selectedUserRoles) {
          if (this.selectedUserRoles[this.definition.class]) {
            return this.selectedUserRoles[this.definition.class][0];
          }
        }


      }
      return null;
    },

    filteredGroups() {
      if (this.groupFilterVal != '') {
        let filteredArray = [];
        _forEach(this.groupsList, (value, key) => {
          if (value.name.toLowerCase().indexOf(this.groupFilterVal.toLowerCase()) != -1) {
            filteredArray.push(value);
          }
        })
        return filteredArray;
      } else {
        return this.groupsList;
      }

    },


    roleBypassGroupManagment() {

      //console.log(this.definition.class);
      //console.log(this.selectedUserRoles.park[0].name);
      if (this.definition.class == "park") {
        if (this.selectedUserRoles.park && this.selectedUserRoles.park[0] && this.roleHasPermission(this.selectedUserRoles.park[0].name, 'park-all-groups')) {
          return true;
        }
        return false
      }
      return false;

    }

  },
  created: function () {

  },
  data() {
    return {
      unlockUniverse: false,
      rolesOpen: false,
      groupsOpen: false,
      showModalRoles: false,
      transferDomElement: null,
      groupFilterVal: ''
    }
  },
  destroyed: function () {
    this.transferDomElement = null
  },
  methods: {
    ...mapMutations({
      changeRole: 'Users/changeRole',
      showLoadingLight: 'UI/showLoadingLight',
      showModal: 'UI/showModal',
      closeModal: 'UI/closeModal',
      setModalParams: 'UI/setModalParams',
      clearGroups: 'Groups/clearGroups',
      addUserGroup: 'Users/addGroup',
      removeUserGroup: 'Users/removeGroup',
    }),
    ...mapActions({
      fetchRoles: 'Roles/fetchRoles',
      fetchGroups: 'Groups/fetchGroups',
      fetchUserGroups: 'Users/fetchGroups',
      editGroups: 'Users/editGroups'
    }),
    handleGroupFilter(val) {
      this.groupFilterVal = val;
    },
    toggleGroups() {
      this.rolesOpen = false;
      this.groupsOpen = !this.groupsOpen;
    },

    toggleRoles() {
      this.groupsOpen = false;
      this.rolesOpen = !this.rolesOpen;
    },
    handleShowModal() {
      this.showModal();
    },
    handleSelectRole(role) {
      this.changeRole({universe: Utils.getUniverseFromRole(role.name), role: role})
      this.closeModal()
      Vue.nextTick()
      this.$emit('change');
    },
    inUserGroups(groupId) {
      let inUser = _find(this.selectedUserGroups[this.definition.class], {id: groupId});
      if (inUser) {
        return true
      }
      return false
    },
    handleCheckGroup(group, forced) {
      if (!this.isReadOnlyGroups) {
        if (forced != null) {
          group.selected = forced
        } else {
          group.selected = !group.selected
        }


        if (group.selected === true) {
          this.addUserGroup({universe: this.definition.class, group: group})
        } else {
          this.removeUserGroup({universe: this.definition.class, group: group})
        }
        this.$emit('change');
      }
    },

    checkAllGroups() {
      this.groupsList.forEach(item => {
        this.handleCheckGroup(item, true);
      })
    },

    uncheckAllGroups() {
      this.groupsList.forEach(item => {
        this.handleCheckGroup(item, false);
      })
    },

    roleHasPermission(roleName, permissionName) {


      let role = _find(this.clientInfos.roles, object => {
        return object.name === roleName
      })


      if (role) {
        let permission = _find(role.permissions, object => {
          return object.name === permissionName
        })

        if (permission) {
          return true
        }
      }

      return false;
    },


  },
  mounted: function () {
    //this.setModalTitle('Modifier le profil')
  },
  name: '',
  props: {
    definition: {
      type: Object
    }
  },
  updated: function () {

  },
  watch: {
    definition(newVal, oldVal) {
      if (newVal != null) {
        if (this.universeRoles) {

          this.unlockUniverse = true;

        } else {
          this.unlockUniverse = false;
        }


        let promiseRoles = this.fetchRoles(this.definition.class)
            .then(response => {

              let params = {};
              Vue.set(params, 'title', window.V.$i18n.t("users.selectProfile"))
              Vue.set(params, 'component', RolesList)
              Vue.set(params, 'height', '100%')
              Vue.set(params, 'props', {})
              Vue.set(params.props, 'rolesList', this.rolesList)
              Vue.set(params.props, 'selectedUniverse', this.definition.class)
              Vue.set(params.props, 'selectedRole', this.universeRoles)
              Vue.set(params.props, 'events', {selectRole: this.handleSelectRole})
              
              this.setModalParams(params)
              
            })
            
            let promiseGroups;
            let promiseUserGroups;
            if (newVal.handleGroups) {
              promiseGroups = this.fetchGroups(this.definition.class)
              if (this.selectedUser.id != null) {
                promiseUserGroups = this.fetchUserGroups({id: this.selectedUser.id, universe: this.definition.class})
              }
              

              Promise.all([promiseGroups, promiseUserGroups])
              .then(() => {
                _forEach(this.groupsList, value => {
                  if (this.inUserGroups(value.id)) {
                    value.selected = true;
                  }
                })
              })
        } else {

          this.clearGroups()
          promiseGroups = new Promise(resolve => {
            resolve()
          })
          promiseUserGroups = new Promise(resolve => {
            resolve()
          })
        }


        Promise.all([promiseRoles, promiseGroups, promiseUserGroups])
            .then(() => {
              setTimeout(() => {


                let params = {};
                Vue.set(params, 'title', window.V.$i18n.t("users.selectProfile"))
                Vue.set(params, 'component', RolesList)
                Vue.set(params, 'props', {})
                Vue.set(params.props, 'rolesList', this.rolesList)
                Vue.set(params.props, 'selectedUniverse', this.definition.class)
                Vue.set(params.props, 'selectedRole', this.universeRoles)
                Vue.set(params.props, 'events', {selectRole: this.handleSelectRole})

                this.setModalParams(params)
                this.showLoadingLight({id: 'universeConfig', show: false})
              }, 300)
            })
      }

    },
    unlockUniverse(newVal, oldVal) {
      if (newVal === false) {
        this.changeRole({universe: this.definition.class, role: null})
        this.$emit('change');
      } else {

      }
    },

    universeRoles(newVal, oldVal) {
      let params = {};
      Vue.set(params, 'title', window.V.$i18n.t("users.selectProfile"))
      Vue.set(params, 'component', RolesList)
      Vue.set(params, 'props', {})
      Vue.set(params.props, 'rolesList', this.rolesList)
      Vue.set(params.props, 'selectedUniverse', this.definition.class)
      Vue.set(params.props, 'selectedRole', newVal)
      Vue.set(params.props, 'events', {selectRole: this.handleSelectRole})

      this.setModalParams(params)
    }
  }
}
</script>

<style lang="scss">


.universe-configurator {

  h2 {
    color: $secondary-color;
    display: flex;
    flex-direction: row;
    margin: 0;
    opacity: 0;
    pointer-events: none;
    transition-property: opacity;

    &.show {
      opacity: 1;
      pointer-events: auto;
    }

    & > * {
      flex: 1 1 auto;
    }

    .icon-container {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;

      .icon-inner {
        $size: 30px;

        background-color: $secondary-color;
        border: solid 3px $secondary-color;
        border-radius: 50%;
        overflow: hidden;
        height: $size;
        width: $size;
        display: flex;
        align-items: center;
        justify-content: center;

        .universe-icon {


          color: $main-white;


          margin: 0;

          path {
            fill: $main-white;
          }

          &.fleet, &.beepiz {
            height: $size*0.6;
          }

          &.park, &.mission, &.bom, &.vision, &.api, &.admin {
            width: $size*0.6;
          }
        }
      }


    }

    .switch-container {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 90px;

      .switch {
        width: 100%;
        margin: 0;
      }
    }


  }

  .universe-configurator-container {

    opacity: 0;
    pointer-events: none;
    transition-property: opacity;

    &.show {
      opacity: 1;
      pointer-events: auto;
    }

  }

  .lock-message {
    color: #6e6e6e;
    text-align: center;
    font-size: 1.2rem;
    font-weight: $bold;

    & > .fa-lock {
      color: rgba($main-black, 0.1);
      font-size: 6rem;
    }
  }

  .mobile-container {
    h3 {
      position: relative;

      .filter {
        background-color: transparent;
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        padding: 0;
        transition-property: transform;
        transform: translate(90%, 0);

        .fa-search, .fa-times {
          color: $main-color;
        }

        .fa-search {

          vertical-align: top;
        }

        input {
          line-height: 1;
          border-bottom: solid 2px $secondary-color;
        }

        &.focus, &.filled {
          transform: translate(0%, 0);
        }
      }
    }
  }

  .mobile-container-inner {
    overflow: hidden;

    .mobile-container-content {
      padding: 10px;
    }
  }

  .role-selector {
    background-color: $main-white;
    border-radius: 4px;

    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    padding: 15px;

    span {
      display: inline-block;
      font-weight: $bold;
      margin-bottom: 15px;
    }

    p {
      font-size: 0.8rem;
      color: lighten($main-black, 30%);
      margin: 0;
      font-style: italic;

    }

    &:hover {
      background-color: $main-color;

      .fa-check {
        color: $main-white;
      }

      span {
        color: $main-white;
      }

      p {
        color: darken($main-white, 10%);
      }
    }


    &.empty {
      background-color: $secondary-color;
      color: $main-white;
    }
  }


}

.group-card {
  background-color: $main-white;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  padding: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  transition-property: background-color, color;
  transition-duration: 300ms;
  display: flex;

  span {
    transition-property: color;
    transition-duration: 300ms;
    font-weight: $bold;
    flex: 1 1 auto;
    text-overflow: ellipsis;
    display: inline-block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    padding-right: 10px;
  }

  .icon {
    align-items: center;
    border: solid 1px $main-color;
    border-radius: 4px;
    display: flex;
    flex: 0 0 18px;
    justify-content: center;

    svg {

      transition-property: color;
      color: rgba(desaturate($main-color, 50%), 0);
    }
  }


  &.active {
    background-color: $main-color;
    color: $main-white;

    svg {
      color: $main-white;
    }
  }

}

.groups-helpers {
  a {
    float: right;
    margin-left: 10px;
    margin-top: 5px;
    font-size: 0.8rem;
    color: $main-color !important;
  }
}

.modal-roles-container {

  & > div {
    background-color: $main-white;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    padding: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    transition-property: background-color;
    transition-duration: 300ms;

    span {
      display: inline-block;
      font-weight: $bold;
      margin-bottom: 15px;
      transition-property: color;
    }

    p {
      font-size: 0.8rem;
      color: darken($main-white, 30%);
      margin: 0;
      transition-property: color;
      font-style: italic;

    }

    .fa-check {
      opacity: 0;
      transition-property: opacity, color;
    }

    &:hover {
      background-color: $main-color;

      .fa-check {
        color: $main-white;
      }

      span {
        color: $main-white;
      }

      p {
        color: darken($main-white, 10%);
      }
    }

    &.active {
      background-color: $secondary-color;


      .fa-check {
        color: $main-white;
        opacity: 1;
      }

      span {
        color: $main-white;
      }

      p {
        color: darken($main-white, 10%);
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/views/users/UniverseConfigurator.vue